import { Controller } from "@hotwired/stimulus"

// Reads a bulk run's state back from the server while it is unfinished.
//
// The run panel subscribes to its action's Turbo stream only once the confirm
// response is in the DOM, so a run that finishes first broadcasts to nobody and
// the panel would sit on "Queued" with no Done button for work that had
// actually completed. Pulling the state closes that window, and keeps the panel
// truthful when the cable is unavailable altogether.
//
// Each response replaces this element, so the rendered state decides whether to
// keep watching: a finished run comes back terminal and the polling stops.
export default class extends Controller {
  static values = {
    src: String,
    terminal: Boolean,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.schedule()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  schedule() {
    if (this.terminalValue || !this.hasSrcValue) return

    this.timer = setTimeout(() => this.refresh(), this.intervalValue)
  }

  async refresh() {
    try {
      const response = await fetch(this.srcValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })
      if (response.ok) window.Turbo.renderStreamMessage(await response.text())
    } catch {
      // Offline, or a blip. Fall through to rescheduling below.
    }

    // Still here means nothing replaced us (the fetch failed, or the run has
    // not moved), so keep watching rather than going quiet.
    if (this.element.isConnected) this.schedule()
  }
}
